<template>
  <div class="unitProduct-page">
  <!-- POTREBNO POPRAVITI DA VLEŽE IZ PRODUCTS -->
    <br/>
    <br/>
    <h1>{{ unitProduct.product }}</h1>

    <p>COMMENTS: {{ unitProduct.comments }}</p>
    <p>MAX. STOCK: {{ unitProduct.stock_max }}</p>
    <p>CURRENT STOCK: {{ unitProduct.stock_curr }}</p>
    <p>ACTUAL STOCK: {{ unitProduct.stock_actual }}</p>
    <hr />

    <!-- <router-link
      :to="{ name: 'unitCleaner', params: { unitId: unit.id } }"
    >
      <div>stock is correct</div>
    </router-link> -->

    <button class="add-btn" @click="$bvModal.show('stock-modal')">stock is not correct</button>
    <b-modal id="stock-modal" hide-footer>
      <template v-slot:modal-title>
        <BaseInput
          class="field"
          label="Actual number of items on stock is:"
          v-model="unitProduct.stock_actual"
          type="number"
          placeholder=""
          :class="{ error: $v.unitProduct.stock_actual.$error }"
          @blur="$v.unitProduct.stock_actual.$touch()"
        />
        <button class="add-btn" @click="changeUnitProductStock">CONFIRM</button>

        <!--Form validation-->
        <template v-if="$v.unitProduct.stock_actual.$error">
          <p v-if="!$v.unitProduct.stock_actual.required" class="errorMessage">
            Please enter actual number of items in stock.
          </p>
        </template>

      </template>
    </b-modal>
  </div>
</template>

<script>
// const url = document.getElementById('textbox1').textContent
import { required } from 'vuelidate/lib/validators'


export default {
  components: {
  },
  data() {
    return {
      url: 'url',
      size: 300,
      id: this.$route.params.unitProductId,
    }
  },
  validations: {
   unitProduct: {
      stock_actual: { required }
    }
    },
     methods: {
    changeUnitProductStock() {
      if (
        confirm('are you sure? This will rewrite excisting stock details for this item')
      ) {
        this.$store.dispatch('unitProduct/editUnitProduct', this.id)
      }
    }
  },
  template: '<qrcode-vue :value="url"></qrcode-vue>',
  props: {
    unitProduct: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style scoped>
.add-btn {
	background: var(--primaryDark);
	color: var(--bright);
	padding: 1em;
	letter-spacing: 3px;
	border-radius: 5px;
	width: 60%;
}

@media screen and (max-width: 780px){
  .add-btn {
  width: 80%;
}
}
</style>
